<template>
  <div class="control">
    <div class="uploaded-list" v-if="filelist.length">
      <div class="pfd-item" v-for="doc in filelist" :key="doc">
        <i class="el-icon-document"></i>
        {{ doc }}（{{ successTip }}）
        <i class="el-icon-error" style="color: red" @click="onDel(doc)"></i>
      </div>
    </div>
    <el-upload
      v-if="filelist.length < uploadMaxLen"
      class="upload-pdf"
      drag
      :show-file-list="false"
      :action="action"
      :data="{ token: token }"
      :name="name"
      :multiple="true"
      :limit="uploadMaxLen"
      :on-success="handleSuccess"
      :on-exceed="handleExceed"
      :before-upload="beforeUpload"
      :auto-upload="autoUpload"
      ref="upload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <template #tip>
        <div class="el-upload__tip">{{ tip }}</div>
      </template>
    </el-upload>
  </div>
</template>

<script>
import { MessageBox } from "element-ui";
export default {
  props: {
    uploadedList: {
      type: Array,
      default: () => [],
    },
    tip: {
      type: String,
      default: "请上传 pdf",
    },
    successTip: {
      default: "pdf文件",
    },
    uploadMaxLen: {
      type: Number,
      default: 1,
    },
    name: {
      type: String,
      default: "pdf",
    },
    action: {
      type: String,
      default: "https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pdf",
    },
    autoUpload: {
      type: Boolean,
      default: true,
    },
    anthorData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      filelist: [],
      token: sessionStorage.getItem("token"),
    };
  },
  computed: {
    headers() {
      return {
        // Authorization: storage.get(ACCESS_TOKEN)
      };
    },
  },
  methods: {
    onDel(doc) {
      MessageBox.confirm("删除当前文件？", {
        showConfirmButton: true,
        showCancelButton: true,
      })
        .then((res) => {
          let resList = this.filelist.filter((item) => item !== doc);
          this.filelist = resList;
        })
        .catch((err) => {
          console.log("_err");
        });
    },
    handleSuccess(res) {
      console.log("_handleSuccess", res);
      const { result, pic_url, file_url } = res;
      if (result === 1) {
        if (this.anthorData.id == "excel") {
          this.filelist.push(file_url);
        } else {
          this.filelist.push(pic_url);
        }
      }
    },
    handleExceed() {
      this.$message.warning(
        `限制最大上传${this.uploadMaxLen}个, 当前已有${this.filelist.length}个文件!`
      );
      // 限最大上传制时调用一次清除已上传列表
      // this.$refs.uploadRef.clearFiles();
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 20;
      if (!isLt1M) {
        this.$message.error("上传pdf大小不能超过 20MB!");
      }
      return isLt1M;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
  },
  watch: {
    uploadedList: {
      handler(newV, oldV) {
        this.filelist = newV;
      },
      immediate: true,
    },
    filelist: {
      handler(newV, oldV) {
        // console.log("_filelist watch", newV)
        this.$emit("update:uploadedList", newV);
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="less">
.upload-pdf {
  width: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & /deep/ .el-upload-dragger {
    width: 250px;
  }
}
</style>
